module.exports = __webpack_public_path__ + "img/1549483718.0e5e53be.jpg";